jQuery(document).ready(function($) {
    Reports = new function()
    {
        this.init = function() {
            jQuery('form.reports-form select[name="report_type"]').change(function(event) {
                var action = jQuery(this).find('option:selected').data('action');
                jQuery('form.reports-form').attr('action', action);

                jQuery('form.reports-form .additional-report-fields').hide();
                jQuery('form.reports-form .additional-report-fields input, form.reports-form .additional-report-fields select').each(function(index, el) {
                    jQuery(el).removeAttr('required');
                });
                var activates = jQuery(this).find('option:selected').attr('data-activates');
                if (typeof activates !== typeof undefined && activates !== false) {
                    jQuery('form.reports-form .additional-report-fields[data-fields="'+activates+'"]').show();
                    jQuery('form.reports-form .additional-report-fields[data-fields="'+activates+'"] input').each(function(index, el) {
                        jQuery(el).prop('required', true);
                    });
                    jQuery('form.reports-form .additional-report-fields[data-fields="'+activates+'"] select').each(function(index, el) {
                        jQuery(el).prop('required', true);
                    });
                }

                if(action) {
                    jQuery('form.reports-form button[type="submit"]').show();
                } else {
                    jQuery('form.reports-form button[type="submit"]').hide();
                }
            });

            jQuery('form.reports-form').submit(function(event) {
                event.preventDefault();
                var href = jQuery(this).attr('action');

                if(jQuery('form.reports-form select[name="report_type"] option:selected').val() == 'boxes') {
                    var boxes = jQuery('form.reports-form select[name="boxes"]').val();

                    href += '?boxes=' + boxes;
                } else if(jQuery('form.reports-form select[name="report_type"] option:selected').val() == 'transactions') {
                    var start_date = jQuery('form.reports-form input[name="start_date"]').val();
                    var end_date   = jQuery('form.reports-form input[name="end_date"]').val();
                    var currency   = jQuery('form.reports-form select[name="currency"]').val();

                    href += '?start_date=' + start_date + '&end_date=' + end_date + '&currency=' + currency;
                } else if(jQuery('form.reports-form select[name="report_type"] option:selected').val() == 'user_actions') {
                    var start_date = jQuery('form.reports-form input[name="ua_start_date"]').val();
                    var end_date   = jQuery('form.reports-form input[name="ua_end_date"]').val();

                    href += '?start_date=' + start_date + '&end_date=' + end_date;
                }

                window.location.href = href;
            });
        };
    }

    Reports.init();
});
